require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-mauro-l-buletti.json") })
        }
      }, "path---en-interviste-mauro-l-buletti");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-mauro-l-buletti!./.cache/json/en-interviste-mauro-l-buletti.json
// module id = 593
// module chunks = 231608221292675